import api from '.'

export async function deleteRole(id: string): Promise<void> {
  await api.delete(`/${id}`)
}
